import React, { useState } from 'react'
import styled from 'styled-components'
import ConfirmPopup from './ConfirmPopup'
import DeleteIcon from '../asset/DeleteIcon'

export type SellPlanWorkspaceTab = 'design' | 'analysis'

interface Props {
  activeTab: SellPlanWorkspaceTab
  onTabChange: (tab: SellPlanWorkspaceTab) => void
  title: string
  onSaveClick?: () => void | Promise<void>
  onDeleteClick?: () => void | Promise<void>
  onCancelClick?: () => void
  onModify?: () => void
  isModify?: boolean
  isCheck?: boolean
}

const tabs: { id: SellPlanWorkspaceTab; label: string }[] = [
  { id: 'design', label: '요금제 설계' },
  { id: 'analysis', label: '구매 단가 및 ESS 이익 비율 분석' },
]

const Shell = styled.div`
  position: relative;
  background: #f0f2f7;
`

const TabRow = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 24px 0;
  gap: 8px;
`

const TabButton = styled.button<{ $active?: boolean }>`
  position: relative;
  z-index: ${(props) => (props.$active ? 3 : 1)};
  display: inline-flex;
  min-width: 148px;
  height: 38px;
  padding: 0 18px;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${(props) => (props.$active ? '#373a40' : 'var(--gray30, #d8dce5)')};
  border-bottom-color: ${(props) => (props.$active ? '#373a40' : '#d8dce5')};
  border-radius: 6px 6px 0 0;
  background: ${(props) => (props.$active ? '#373a40' : '#f4f5f8')};
  box-shadow: 0px 4px 16px 0px #00000029;
  clip-path: inset(0 -16px -16px -16px);
  color: ${(props) => (props.$active ? '#ffffff' : '#373a40')};
  font-family: SUIT;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  ${(props) =>
    props.$active &&
    `
    &::after {
      position: absolute;
      right: -1px;
      bottom: -2px;
      left: -1px;
      height: 3px;
      background: #373a40;
      content: '';
    }
  `}
`

const TitleBar = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  min-height: 66px;
  padding: 1em 1.5em;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: #373a40;
  box-shadow: 0px 4px 16px 0px #00000029;
  color: #ffffff;
  font-family: 'SUIT';
`

const Title = styled.div`
  font-size: 1.37rem;
  font-weight: 700;
`

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 8.7em;
  color: #333333;
`

const ActionButton = styled.button`
  width: 41px;
  height: 29px;
  margin-right: 8px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background-color: #e6e6e6;
  cursor: pointer;
`

const CancelButton = styled(ActionButton)`
  background-color: transparent;
  color: #cccccc;
`

const SaveButton = styled(ActionButton)`
  margin: 0;
  background-color: #74e3c2;
`

export const SellPlanWorkspaceHeader = ({
  activeTab,
  onTabChange,
  title,
  onSaveClick,
  onDeleteClick,
  onCancelClick,
  onModify,
  isModify,
  isCheck,
}: Props) => {
  const [showDeletePopup, setShowDeletePopup] = useState(false)
  const [showSavePopup, setShowSavePopup] = useState(false)

  const handleRealDelete = async () => {
    if (onDeleteClick) {
      await onDeleteClick()
    }
  }

  const handleRealSave = async () => {
    if (onSaveClick) {
      await onSaveClick()
    }
  }

  return (
    <>
      <Shell>
        <TabRow>
          {tabs.map((tab) => (
            <TabButton
              key={tab.id}
              type="button"
              $active={activeTab === tab.id}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label}
            </TabButton>
          ))}
        </TabRow>
        <TitleBar>
          <Title>{title}</Title>
          <ButtonBox>
            {isModify ? (
              <ActionButton onClick={() => setShowDeletePopup(true)}>
                삭제
              </ActionButton>
            ) : (
              <CancelButton onClick={onCancelClick}>취소</CancelButton>
            )}

            {isCheck ? (
              <SaveButton onClick={onModify}>수정</SaveButton>
            ) : (
              <SaveButton onClick={() => setShowSavePopup(true)}>
                저장
              </SaveButton>
            )}
          </ButtonBox>
        </TitleBar>
      </Shell>

      {showDeletePopup && (
        <ConfirmPopup
          type="delete"
          title="삭제하시겠습니까?"
          icon={<DeleteIcon />}
          confirmText="삭제하기"
          cancelText="취소"
          onClose={() => setShowDeletePopup(false)}
          onConfirm={handleRealDelete}
        />
      )}

      {showSavePopup && (
        <ConfirmPopup
          type="save"
          title="저장하시겠습니까?"
          confirmText="저장하기"
          cancelText="돌아가기"
          onClose={() => setShowSavePopup(false)}
          onConfirm={handleRealSave}
        />
      )}
    </>
  )
}
